var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlug = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48317 3.10102C9.48317 2.5053 9.00023 2.02237 8.40452 2.02237C7.8088 2.02237 7.32587 2.5053 7.32587 3.10102V7.01112H6.24722C5.45293 7.01112 4.80902 7.65503 4.80902 8.44931V12.7639C4.80902 15.1468 6.74074 17.0784 9.12362 17.0784H10.9214V20.9437C10.9214 21.5394 11.4043 22.0224 12 22.0224C12.5957 22.0224 13.0787 21.5394 13.0787 20.9437V17.0784H14.8764C17.2594 17.0784 19.191 15.1468 19.191 12.7639V8.44931C19.191 7.65503 18.5471 7.01112 17.7528 7.01112H16.6742V3.10102C16.6742 2.5053 16.1912 2.02237 15.5955 2.02237C14.9998 2.02237 14.5169 2.5053 14.5169 3.10102V7.01112H9.48317V3.10102Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlug);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Plug.2f37d41e849cdd9f31e7798217556d5e.svg";